import React from 'react'
import { Icon } from '@iconify/react'
import { useTranslation } from 'react-i18next'
import { Block } from '@comp/crRender'
import SectionCard from '../../shared/SectionCard'
import './style.css'
import { generator } from '@/utils/NumbersUtils'

const Accreditations = ({ accredations }) => {
    const { t } = useTranslation()

    return (
        <Block isRender={accredations?.length > 0}>
            <SectionCard icon="mdi:certificate" titleKey="accredations">
                <div className="accreditations-grid">
                    {accredations?.mapWithKey((acc) => (
                        <div key={acc.key} className="accreditation-item">
                            <div className="accreditation-icon">
                                <Icon icon="mdi:certificate" />
                            </div>
                            <div className="accreditation-name-container">
                                <div className="accreditation-name">{acc.value}</div>
                                <div className="accreditation-status">{t("certified")}</div>
                            </div>
                        </div>
                    ))}
                </div>
            </SectionCard>
        </Block>
    )
}

export default Accreditations

